<template>
  <div id="app">
    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>
    
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
*{padding:0;margin:0}
.fade-enter{
  opacity: 0;
}
.fade-enter-active{
  transition: opacity 1s;
}
@font-face {
  font-family: 'webfont';
  font-display: swap;
  src: url('//at.alicdn.com/t/webfont_btcsin4xdj.eot'); /* IE9*/
  src: url('//at.alicdn.com/t/webfont_btcsin4xdj.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */
  url('//at.alicdn.com/t/webfont_btcsin4xdj.woff2') format('woff2'),
  url('//at.alicdn.com/t/webfont_btcsin4xdj.woff') format('woff'), /* chrome、firefox */
  url('//at.alicdn.com/t/webfont_btcsin4xdj.ttf') format('truetype'), /* chrome、firefox、opera、Safari, Android, iOS 4.2+*/
  url('//at.alicdn.com/t/webfont_btcsin4xdj.svg#Alibaba-PuHuiTi-Regular') format('svg'); /* iOS 4.1- */
}
#app {
  font-family:"webfont" !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue